import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=30e9fa5e&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.scss?vue&type=style&index=0&id=30e9fa5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9fa5e",
  null
  
)

export default component.exports